import { render, staticRenderFns } from "./AttrTypeSelect.vue?vue&type=template&id=9890ceee&scoped=true"
import script from "./AttrTypeSelect.vue?vue&type=script&lang=js"
export * from "./AttrTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./AttrTypeSelect.vue?vue&type=style&index=0&id=9890ceee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9890ceee",
  null
  
)

export default component.exports